/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[actions][_ngcontent-%COMP%]:empty(), [custom-label][_ngcontent-%COMP%]:empty(){display:none}"];
export { styles as styles };
